import { getAdminRuntime } from '../../modules/api';

const LEGACY = { runtime: 'legacy', places: 'dadata', countries: [] };

let pending = null;

export function loadAdminRuntime() {
  if (!pending) {
    pending = getAdminRuntime()
      .then((res) => res?.data || LEGACY)
      .catch(() => LEGACY);
  }
  return pending;
}
